import { createRoot } from "react-dom/client";
import App from "./App.tsx";

// Self-hosted fonts (GDPR — no requests to Google's servers).
// Body: Mulish · Display/headings: Poppins · Arabic (RTL): Cairo + IBM Plex Sans Arabic
import "@fontsource/mulish/400.css";
import "@fontsource/mulish/500.css";
import "@fontsource/mulish/600.css";
import "@fontsource/mulish/700.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";
import "@fontsource/cairo/400.css";
import "@fontsource/cairo/600.css";
import "@fontsource/cairo/700.css";
import "@fontsource/cairo/800.css";
import "@fontsource/ibm-plex-sans-arabic/400.css";
import "@fontsource/ibm-plex-sans-arabic/600.css";
import "@fontsource/ibm-plex-sans-arabic/700.css";

import "./index.css";

// ⚠️ TEMPORAL (diagnóstico de jank en webviews): aplica ?noblur=1 antes del
// primer paint. Sin query params no hace nada. Ver src/lib/perf-flags.ts.
import { installPerfKillSwitches } from "./lib/perf-flags";
installPerfKillSwitches();

// ?lang=xx (enlaces de los emails y del botón de demo) fija el idioma de la visita en las dos
// claves que usa la web (landing nueva: ulture_lang · resto: ulture-language) antes de montar React.
try {
  const urlLang = new URLSearchParams(location.search).get("lang");
  if (urlLang && ["es", "en", "it", "fr", "nl", "ar", "zh"].includes(urlLang)) {
    localStorage.setItem("ulture_lang", urlLang);
    localStorage.setItem("ulture-language", urlLang);
  }
} catch { /* sin localStorage */ }

// Tras publicar una versión nueva, los archivos con hash de la anterior dejan de existir: si una
// pestaña abierta intenta cargarlos, se recarga una vez (en vez de quedarse en blanco).
window.addEventListener("vite:preloadError", (event) => {
  try {
    if (sessionStorage.getItem("ulture_reloaded_after_error")) return;
    sessionStorage.setItem("ulture_reloaded_after_error", "1");
  } catch { /* sin sessionStorage */ }
  event.preventDefault();
  window.location.reload();
});

// En "/" se pide ya el chunk de la home y en las páginas nuevas de Claude Design el de su envoltorio
// (src/ulture/UltureSite.tsx), en paralelo con el arranque de React.
if (/^\/?$/.test(location.pathname)) void import("./landing/inicio/HomeInicio");
else if (/^\/(tactic|pest|sobre-nosotros|partners|blog|contacto)\/?$/.test(location.pathname)) void import("./ulture/UltureSite");

createRoot(document.getElementById("root")!).render(<App />);
